import React, { useEffect } from 'react';
import './PageLoader.css';

const scrollTop = () => {
  if (typeof window === 'undefined') return;

  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  const mainContent = document.querySelector('.main-content');
  if (mainContent && typeof mainContent.scrollTo === 'function') {
    mainContent.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }
};

const PageLoader = ({
  message = 'Загрузка...',
  pageClassName = '',
  containerClassName = '',
  scrollOnMount = true,
}) => {
  useEffect(() => {
    if (!scrollOnMount) return;
    if (typeof window === 'undefined') return;
    const frameId = window.requestAnimationFrame(scrollTop);
    return () => window.cancelAnimationFrame(frameId);
  }, [scrollOnMount]);

  const loaderContent = (
    <div className={`page-loader-container${containerClassName ? ` ${containerClassName}` : ''}`}>
      <div className="page-loader-spinner" aria-hidden="true"></div>
      <p className="page-loader-text">{message}</p>
    </div>
  );

  if (!pageClassName) return loaderContent;

  return <div className={pageClassName}>{loaderContent}</div>;
};

export default PageLoader;
